import React, { useState } from "react";

function HeroSection() {
  const [hoveredCard, setHoveredCard] = useState(null);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const cards = [
    {icon:"🏥", label:"Health", price:"Rs 99"},
    {icon:"🦺", label:"Personal Accident", price:"Rs 149"},
    {icon:"✈️", label:"Domestic Travel", price:"Rs 199"},
    {icon:"👨‍👩‍👧", label:"Family Floater", price:"Rs 499"},
  ];

  return (
    <section style={{background:"linear-gradient(135deg, #0f172a 0%, #134e4a 60%, #0c4a6e 100%)", padding:"80px 48px", minHeight:"90vh", display:"flex", alignItems:"center", justifyContent:"space-between", flexWrap:"wrap", gap:"40px", position:"relative", overflow:"hidden"}}>
      <div style={{position:"absolute", top:"-100px", left:"-100px", width:"400px", height:"400px", background:"radial-gradient(circle, rgba(13,148,136,0.15) 0%, transparent 70%)", pointerEvents:"none"}} />
      <div style={{position:"absolute", bottom:"-100px", right:"-100px", width:"500px", height:"500px", background:"radial-gradient(circle, rgba(8,145,178,0.12) 0%, transparent 70%)", pointerEvents:"none"}} />

      <div style={{maxWidth:"580px", position:"relative", zIndex:1}}>
        <div style={{display:"inline-flex", alignItems:"center", gap:"8px", background:"rgba(13,148,136,0.15)", color:"#5eead4", padding:"8px 16px", borderRadius:"999px", fontSize:"13px", fontWeight:"700", marginBottom:"24px", border:"1px solid rgba(13,148,136,0.3)"}}>
          🤝 In partnership with Himalayan Life Insurance
        </div>
        <h1 style={{fontSize:"54px", fontWeight:"900", color:"#fff", margin:"0 0 20px", lineHeight:"1.1"}}>
          Insurance for{" "}
          <span className="gradient-text">every Nepali</span>
        </h1>
        <p style={{fontSize:"18px", color:"#94a3b8", lineHeight:"1.8", marginBottom:"40px"}}>
          Buy health, accident, travel and more — instantly online. Starting at just <strong style={{color:"#2dd4bf"}}>Rs 99/week</strong>. Coverage up to <strong style={{color:"#2dd4bf"}}>100x your premium</strong>. No paperwork. No hassle.
        </p>

        <div style={{display:"flex", gap:"16px", marginBottom:"56px", flexWrap:"wrap"}}>
          <button
            onClick={() => scrollTo("plans")}
            style={{background:"linear-gradient(135deg, #0d9488, #0891b2)", color:"#fff", border:"none", borderRadius:"999px", padding:"16px 32px", fontWeight:"700", fontSize:"16px", cursor:"pointer", boxShadow:"0 8px 24px rgba(13,148,136,0.4)", transition:"all 0.2s"}}
            onMouseEnter={e => { e.currentTarget.style.transform="translateY(-2px)"; e.currentTarget.style.boxShadow="0 12px 32px rgba(13,148,136,0.5)"; }}
            onMouseLeave={e => { e.currentTarget.style.transform="translateY(0)"; e.currentTarget.style.boxShadow="0 8px 24px rgba(13,148,136,0.4)"; }}>
            Browse Plans →
          </button>
          <button
            onClick={() => scrollTo("howitworks")}
            style={{background:"transparent", color:"#fff", border:"2px solid rgba(255,255,255,0.2)", borderRadius:"999px", padding:"16px 32px", fontWeight:"700", fontSize:"16px", cursor:"pointer", transition:"all 0.2s"}}
            onMouseEnter={e => { e.currentTarget.style.borderColor="rgba(13,148,136,0.6)"; e.currentTarget.style.color="#2dd4bf"; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor="rgba(255,255,255,0.2)"; e.currentTarget.style.color="#fff"; }}>
            Learn More
          </button>
        </div>

        <div style={{display:"flex", gap:"40px", flexWrap:"wrap"}}>
          {[["Rs 99","Starting/week"],["100x","Coverage"],["2 min","To get covered"],["24/7","Support"]].map(([val, label]) => (
            <div key={label} style={{display:"flex", flexDirection:"column"}}>
              <strong style={{fontSize:"24px", color:"#2dd4bf", fontWeight:"900"}}>{val}</strong>
              <span style={{fontSize:"13px", color:"#64748b"}}>{label}</span>
            </div>
          ))}
        </div>
      </div>

      <div style={{display:"flex", flexDirection:"column", gap:"16px", position:"relative", zIndex:1}}>
        {cards.map((item, i) => (
          <div key={item.label}
            onMouseEnter={() => setHoveredCard(i)}
            onMouseLeave={() => setHoveredCard(null)}
            onClick={() => scrollTo("plans")}
            style={{display:"flex", alignItems:"center", gap:"16px", background: hoveredCard === i ? "rgba(13,148,136,0.15)" : "rgba(255,255,255,0.05)", border: hoveredCard === i ? "1px solid rgba(13,148,136,0.5)" : "1px solid rgba(255,255,255,0.08)", borderRadius:"16px", padding:"16px 24px", minWidth:"240px", cursor:"pointer", transition:"all 0.25s", transform: hoveredCard === i ? "translateX(8px)" : "translateX(0)", boxShadow: hoveredCard === i ? "0 8px 24px rgba(13,148,136,0.15)" : "none"}}>
            <span style={{fontSize:"28px"}}>{item.icon}</span>
            <div>
              <div style={{color:"#fff", fontWeight:"700", fontSize:"15px"}}>{item.label} Insurance</div>
              <div style={{color:"#2dd4bf", fontWeight:"800", fontSize:"14px"}}>from {item.price}/week</div>
            </div>
            <span style={{marginLeft:"auto", color: hoveredCard === i ? "#2dd4bf" : "#334155", fontSize:"18px", transition:"color 0.2s"}}>→</span>
          </div>
        ))}
      </div>
    </section>
  );
}

export default HeroSection;